export const black = '#000'
export const white = '#FFF'

export const green = {
  500: '#00d181',
}

export const blue = { 
  100: '#4b4b7d',
  200: '#313154',
  300: '#201f34',
  400: '#626291',
}

export const red = {
  100: '#FFFDFE',
  200: '#c4a000',
  500: '#fffa6d',
}

export const grey = {
  100: '#181818',
  200: '#2e3436',
  300: '#1b1b1b',
  400: '#aa9585',
  500: '#555753',
  600: '#f3f3f3',
  800: '#f7f4f2',
  900: '#9797d3',
  1000: '#f5f5f5',
  1100: '#e0e0e0',
}
